<script setup>

    import { onMounted, ref, watch } from 'vue'
    import { factory } from '@/Validators'

    const props = defineProps({
        modelValue: {
            type: [String, Number, null],
        },
        validate: {
            type: Array,
            default: () => []
        },
        type: {
            type: String
        },
        placeholder: {
            type: String,
            default: ''
        },
        input_class: {
            type: String,
            default: ''
        },
        autocomplete: {
            type: String,
            default: 'new-password'
        },
        disabled: {
            type: Boolean,
            default: false
        }
    })

    const emit = defineEmits(['update:modelValue', 'reference:set'])
    const input = ref()
    const text = ref(null)
    const isValid = ref(true)

    onMounted(() => {
        if (input.value?.hasAttribute('autofocus')) {
            input.value.focus()
        }

        if (input.value) {
            emit('reference:set', input.value)
        }
    })

    watch(text, (value) => {
        if (value == null) {
            return;
        }

        if (props.validate.includes('nullable') && value == '') {
            emit('update:modelValue', value)
            isValid.value = true
            return;
        }

        for (let i in props.validate) {
            const validator = factory(props.validate[i])

            if (validator.isValid(value) == false) {
                isValid.value = false
                return;
            }

            isValid.value = true
        }
        emit('update:modelValue', value)

    }, {immediate: true})

    watch(() => props.modelValue, (value) => {
        text.value = value
    }, {immediate: true})

    defineExpose({ focus: () => input.value.focus() })

</script>

<template>

    <input
        :class="[
            'placeholder:text-stone-400 rounded-md shadow-sm peer tracking-wide w-full px-2.5 py-1.5 text-sm',
            {
                'text-stone-700': !props.input_class.includes('text-'),
            },
            props.input_class,
            !isValid ? 'border-lifeworx-red-500 focus:ring-1 focus:border-lifeworx-red-500 focus:ring-lifeworx-red-500 bg-lifeworx-red-500 bg-opacity-10' : 'border-stone-400 focus:border-lifeworx-blue-600 focus:ring-lifeworx-blue-600 focus:ring-1 focus:outline-none'
        ]"
        v-model="text"
        :type="type"
        :placeholder="props.placeholder"
        :disabled="props.disabled"
        ref="input"
        :autocomplete="props.autocomplete"
    />

</template>
